import { render } from "./PanelHotel.vue?vue&type=template&id=c33517d8&scoped=true"
import script from "./PanelHotel.vue?vue&type=script&lang=js"
export * from "./PanelHotel.vue?vue&type=script&lang=js"

import "./PanelHotel.vue?vue&type=style&index=0&id=c33517d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33517d8"]])

export default __exports__